import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import AnimatedSection from './AnimatedSection';
import { HandDrawnDivider } from './DecorativeElements';

const CONTACT_SCRIPT_URL = 'https://elfsightcdn.com/platform.js';

const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];

  // Load Elfsight script when Contact mounts so the widget div is already in the DOM
  useEffect(() => {
    const existing = document.querySelector(`script[src="${CONTACT_SCRIPT_URL}"]`);
    if (existing) return;

    const script = document.createElement('script');
    script.src = CONTACT_SCRIPT_URL;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="contact" className="section-padding bg-rustic-cream texture-overlay">
      <div className="container mx-auto">
        <AnimatedSection animation="fadeInUp">
          <div className="text-center mb-16">
            <h2 className="section-heading">{t.contact.title}</h2>
            <p className="text-base sm:text-lg md:text-xl font-serif text-terracotta italic mb-4 px-4">
              {t.contact.subtitle}
            </p>
            <HandDrawnDivider />
          </div>
        </AnimatedSection>
        
        <AnimatedSection animation="fadeIn" delay={200}>
          <div className="elfsight-app-container w-full overflow-x-auto">
            <div
              className="elfsight-app-2a605897-4411-4d83-b51f-45f7af78c32f"
              data-elfsight-app-lazy
              style={{ minHeight: '400px', width: '100%' }}
            />
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Contact;
